import React, {useEffect, useState} from 'react'
import {
  Box,
  Typography,
  IconButton,
  Card,
  CardContent,
  CardMedia,
  Tooltip,
  Paper,
  MenuItem,
  Input,
  InputAdornment,
  Popover,
  Button,
  FormControl,
  Grid,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Transitions from './Transitions';
import Watermark from './Watermark';
import TrimVideo from './TrimVideo';

const EditingToolOption = [
        {id:1,label: "Transitions", value : "transitions"},
        {id:2,label: "Trim Video", value : "trimVideo"},
        {id:3,label: "Watermark", value : "watermark"}
    ]

const WaterMarkType = [
    {id:1, label:"Text", value:"text"},
    {id:2, label:"Image", value:"image"}
]



const EditingTools = ({activeVideo, veo2Videos, initializeFFmpeg, selectedTransition, setSelectedTransition}) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedWaterMarkType, setSelectedWaterMarkType] = useState( {id:1, label:"Text", value:"text"},);
    const [selectedEditingOption, setSelectedEditingOption] = useState({id:1,label: "Transitions", value : "transitions"})
     const [currentVideoForEdit, setCurrentVideoForEdit] = useState(null);
    const open = Boolean(anchorEl);
    const theme = localStorage.getItem('theme');

    useEffect(()=>{
      setCurrentVideoForEdit(activeVideo)
    },[activeVideo])


    const handleWaterMarkTypeClick = (ele) => {
        setSelectedWaterMarkType(ele)
    }

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelectTool = (ele) => {
        setSelectedEditingOption(ele)
        handleClose();
    };

    const renderTabContent = () => {
    switch (selectedEditingOption?.value) {
      case "transitions":
        return (
            <Transitions selectedTransition={selectedTransition} setSelectedTransition={setSelectedTransition}/>
        );
      case "trimVideo":
        return (
            <TrimVideo activeVideo={currentVideoForEdit} veo2Videos={veo2Videos}/>
        );
      case "watermark":
        return (
            <Watermark  selectedWaterMarkType={selectedWaterMarkType} activeVideo={currentVideoForEdit} veo2Videos={veo2Videos}/>
        );
      default:
        return <Transitions/>;
    }
  };

  return (
    <div>
        <Box sx={{}}>
            <Box sx={{display:"flex", flexDirection:"row", columnGap:4, alignItems:"center", mb:3, padding:"0px"}}>
            <Typography variant="body2" sx={{color:"rgba(255, 255, 255, 1)", font:"Inter", fontSize:"20px", fontWeight:700, fontStyle:"normal", lineHeight:"20px", letterSpacing:"0.1px"}}>Edit your video:</Typography>
            <FormControl>
            <Button
                onClick={handleOpen}
                sx={{
                color: selectedEditingOption?.label  ? "rgba(255, 255, 255, 1)" :  "rgba(202, 196, 208, 1)",
                backgroundColor: "#2F355F",
                borderRadius: "8px",
                height: "42px",
                minWidth: "120px",
                textTransform: "none",
                fontFamily: "Inter",
                fontWeight:400,
                "&:hover": {
                    backgroundColor: "#373E6D",
                },
                }}
            >
                {selectedEditingOption?.label || "Transitions"}
                <ArrowDropDownIcon
                sx={{ color: selectedEditingOption?.label  ? "rgba(255, 255, 255, 1)" : "rgba(202, 196, 208, 1)", marginLeft: "auto" }}
                />
            </Button>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
                }}
                sx={{
                "& .MuiPaper-root": {
                    backgroundColor: "#2F355F",
                    color: "white",
                    borderRadius: "8px",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                    maxHeight: "300px",
                    width: "140px",
                    marginTop: "4px",
                },
                }}
            >

               <Box sx={{ overflowY: "auto", maxHeight: 250,  }}>
                           {EditingToolOption?.map((ele) => (
                             <MenuItem
                               key={ele?.id}
                               onClick={() => handleSelectTool(ele)}
                               sx={{
                                 color: "rgba(255, 255, 255, 1)",
                                 "&:hover": { backgroundColor: "#373E6D" },
                                 "&.Mui-selected": { backgroundColor: "#373E6D" },
                                 py: 1.5,
                                 fontSize: 14,
                                 fontFamily: 'Inter',
                               }}
                             >
                               {ele?.label}
                             </MenuItem>
                           ))}
                         </Box>
            </Popover>
            </FormControl>
            {/* {
                selectedEditingOption?.value  === "watermark" &&
                <Box sx={{display:"flex", flexDirection:"row", columnGap:"32px", alignItems:"center"}}>
                  <Typography variant="body2" sx={{color:"rgba(255, 255, 255, 1)", font:"Inter", fontSize:"20px", fontWeight:700, fontStyle:"normal", lineHeight:"20px", letterSpacing:"0.1px"}}>Type:</Typography>   
                   <Grid container spacing={2} justifyContent="start">
                        {WaterMarkType.map((ele) => (
                        <Grid item key={ele?.id}>
                            <Button
                            variant="outlined"
                            onClick={() => handleWaterMarkTypeClick(ele)}
                            sx={{
                            width: "auto",
                            height: "44px ",
                            borderRadius:"10px",
                            backgroundColor: selectedWaterMarkType?.id === ele?.id ? "#3a3f69" : "#30355f",
                                color: "#FFFFFF",
                                "&:hover": {
                                backgroundColor: selectedWaterMarkType?.id === ele?.id ? "#373E6D" : "",
                                 borderColor: selectedWaterMarkType?.id === ele?.id ? "rgba(255, 255, 255, 0.70)" : "rgba(255, 255, 255, 0.70)",
                                },
                                borderColor: selectedWaterMarkType?.id === ele?.id ? "rgba(255, 255, 255, 0.70)" : "rgba(255, 255, 255, 0.30)",
                                p: 1.5, 
                            }}
                            >
                            {ele?.label}
                            </Button>
                        </Grid>
                        ))}
                    </Grid> 
                </Box>
            } */}
            </Box>
                   
                   {/* Tab Content */}
            <Box>
                {renderTabContent()}
            </Box>
        </Box>
    </div>
  )
}

export default EditingTools